import { normalize, schema } from 'normalizr';
import schemas from 'edrolo/schemas';
import { trackAnalytics } from 'edrolo/analytics';

import * as bookmarkConstants from './constants';
import * as BookmarksAPI from './api';

export const loadUserBookmarks = (userId, classId) => {
  return async (dispatch) => {
    dispatch({
      type: bookmarkConstants.BOOKMARKS_FETCH_REQUEST,
      userId,
      classId,
    });

    const response = await BookmarksAPI.loadBookmarks(userId, classId);
    if (response.ok) {
      const userBookmarks = normalize(
        { bookmarks: response.body },
        {
          bookmarks: new schema.Array(schemas.userBookmark),
        }
      );
      dispatch({
        type: bookmarkConstants.BOOKMARKS_FETCH_SUCCESS,
        bookmarks: userBookmarks.entities.bookmarks || {},
      });
    } else {
      dispatch({
        type: bookmarkConstants.BOOKMARKS_FETCH_ERROR,
        errors: response.failureReason,
      });
    }
  };
};

export const saveBookmark = (chunkId, bookmarkData) => {
  return async (dispatch) => {
    dispatch({
      type: bookmarkConstants.BOOKMARK_SAVE_REQUEST,
      chunkId,
      ...trackAnalytics('bookmarked chunk', { chunk_id: chunkId }),
    });

    const response = await BookmarksAPI.saveBookmark(chunkId, bookmarkData);
    if (response.ok) {
      dispatch({
        type: bookmarkConstants.BOOKMARK_SAVE_SUCCESS,
        bookmark: response.body.bookmark,
        chunkId,
      });
    } else {
      dispatch({
        type: bookmarkConstants.BOOKMARK_SAVE_ERROR,
        errors: response.failureReason,
      });
    }
  };
};

export const removeBookmark = (chunkId) => {
  return async (dispatch) => {
    dispatch({ type: bookmarkConstants.BOOKMARK_REMOVE_REQUEST });

    const response = await BookmarksAPI.saveBookmark(chunkId, null, !!'delete');

    if (response.ok) {
      dispatch({
        type: bookmarkConstants.BOOKMARK_REMOVE_SUCCESS,
        chunkId,
      });
    } else {
      dispatch({
        type: bookmarkConstants.BOOKMARK_REMOVE_ERROR,
        errors: response.failureReason,
      });
    }
  };
};
